// cafe/client/src/hooks/useLanguageLink.js
import { useTranslation } from 'react-i18next';

/**
 * Hook personalizado para generar rutas con el prefijo del idioma actual.
 * @returns {object} Un objeto con la función `langLink`.
 */
export const useLanguageLink = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  /**
   * Añade el prefijo del idioma a una ruta.
   * @param {string} path - La ruta base (ej: '/explore' o '/my/profile').
   * @returns {string} La ruta completa con el idioma (ej: '/es/explore').
   */
  const langLink = (path) => {
    // Nos aseguramos de que la ruta base no tenga ya un prefijo de idioma
    if (
      path.startsWith('/es/') ||
      path.startsWith('/en/') ||
      path.startsWith('/pt/')
    ) {
      return path;
    }
    // Añadimos el prefijo
    return `/${currentLang}${path}`;
  };

  return { langLink };
};
